export enum PostHogEvent {
  // Position
  positionAdd = 'Position Add',
  positionUpdate = 'Position Update',
  positionDelete = 'Position Delete',

  positionAddGetStarted = 'Position Add Get Started',

  // Resume
  resumeAdd = 'Resume Add',
  resumeDelete = 'Resume Delete',

  resumeAddGetStarted = 'Resume Add Get Started',

  // Interview
  interviewAddGetStarted = 'Interview Add Get Started',

  interviewNormalAdd = 'Interview Normal Add',
  interviewCodingAdd = 'Interview Coding Add',
  interviewDelete = 'Interview Delete',
  interviewNormalLaunch = 'Interview Normal Launch',
  interviewCodingLaunch = 'Interview Coding Launch',
  interviewNormalContinue = 'Interview Normal Continue',
  interviewCodingContinue = 'Interview Coding Continue',
  interviewNormalFreeTrialLaunch = 'Interview Normal Free Trial Launch',
  interviewCodingFreeTrialLaunch = 'Interview Coding Free Trial Launch',
  interviewManuallyEnd = 'Interview Manually End',

  interviewNoStartTime = 'Interview No Start Time',
  interviewFreeTrialExpired = 'Interview Free Trial Expired',
  interviewPingError = 'Interview Ping Error',
  interviewException = 'Interview Exception',
  interviewPingException = 'Interview Ping Exception',
  interviewPausedByHuman = 'Interview Paused by Human',
  interviewDeepgramError = 'Interview Deepgram Error',
  interviewDeepgramClosed = 'Interview Deepgram Closed',
  interviewMicError = 'Interview Mic Error',
  interviewMicClosed = 'Interview Mic Closed',
}
